import { format } from "date-fns"
import { FiEye } from "react-icons/fi"
import { useHistory } from 'react-router-dom'
import Table from "../../../../components/Table"
import Spinner from "../../../../components/Spinner"

export function ListaProjetos({ projetos }) {
	const history = useHistory()

	if(!projetos) {
		return <Spinner />
	}

	return (
		<div className="flex flex-col gap-4 items-center justify-center">
			<h1 style={{ fontSize: 18 }}>Meus projetos</h1>

			<Table 
				headers={[
					{ name: 'nome', value: 'Projeto' },
					{ name: 'inicio', value: 'Início', centered: true },
					{ name: 'fim', value: 'Fim', centered: true }
				]}
				data={projetos.map(proj => ({
					id: proj.id,
					nome: proj.nome,
					inicio: format(new Date(proj.inicio), 'dd/MM/yyyy'),
					fim: format(new Date(proj.fim), 'dd/MM/yyyy')
				}))}
				actions={[
					{
						action: item => {
							history.push(`/projeto/${item.id}`)
						},
						icon: FiEye,
						iconSize: 16,
						name: 'Abrir'
					}
				]}
				emptyLabel="Nenhum projeto nesta lista"
			/>
		</div>
	)
}